// 26.1.12 Reflect.preventExtensions(target)
var $export = require('./_export');
var anObject = require('./_an-object');
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});



//////////////////
// WEBPACK FOOTER
// /home/kepler/code/github/expense-manager-firebase/~/core-js/modules/es6.reflect.prevent-extensions.js
// module id = ../../../../core-js/modules/es6.reflect.prevent-extensions.js
// module chunks = 0